import { ISettlementRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

export class SettlementRepositoryImpl extends ISettlementRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
  }

  async getSummary(pharmacyId, startDate, endDate) {
    try {
      const response = await this.apiClient.get('/settlement/summary', {
        params: { pharmacy_id: pharmacyId, start_date: startDate, end_date: endDate },
      });
      return response;
    } catch (error) {
      LogUtil.error('[SettlementRepository] 정산 요약 조회 실패:', error);
      throw error;
    }
  }

  async getPgPayments(pharmacyId, startDate, endDate, params = {}) {
    try {
      const response = await this.apiClient.get('/settlement/pg-payments', {
        params: {
          pharmacy_id: pharmacyId,
          start_date: startDate,
          end_date: endDate,
          ...params,
        },
      });
      return response;
    } catch (error) {
      LogUtil.error('[SettlementRepository] PG 결제 내역 조회 실패:', error);
      throw error;
    }
  }

  async getPointTransactions(pharmacyId, startDate, endDate, params = {}) {
    try {
      const response = await this.apiClient.get('/settlement/point-transactions', {
        params: {
          pharmacy_id: pharmacyId,
          start_date: startDate,
          end_date: endDate,
          ...params,
        },
      });
      return response;
    } catch (error) {
      LogUtil.error('[SettlementRepository] 포인트 거래 내역 조회 실패:', error);
      throw error;
    }
  }

  async getCouponUsages(pharmacyId, startDate, endDate, params = {}) {
    try {
      const response = await this.apiClient.get('/settlement/coupon-usages', {
        params: {
          pharmacy_id: pharmacyId,
          start_date: startDate,
          end_date: endDate,
          ...params,
        },
      });
      return response;
    } catch (error) {
      LogUtil.error('[SettlementRepository] 쿠폰 사용 내역 조회 실패:', error);
      throw error;
    }
  }

  // 정산 캘린더 일별×채널 집계 (v2 I-2). 약국은 토큰으로 식별
  async getDaily(month) {
    try {
      return await this.apiClient.get('/settlement/daily', { params: { month } });
    } catch (error) {
      LogUtil.error('[SettlementRepository] 정산 캘린더 조회 실패:', error);
      throw error;
    }
  }

  // 팜페이포인트 현황 KPI (v2 H-4, 10/7 배포). 약국은 토큰으로 식별
  async getPaypointKpi(month) {
    try {
      return await this.apiClient.get('/settlement/paypoint-kpi', { params: { month } });
    } catch (error) {
      LogUtil.error('[SettlementRepository] 팜페이포인트 KPI 조회 실패:', error);
      throw error;
    }
  }
}
